import { DateTime } from "luxon";
import * as Yup from "yup";

import { DISPLAY_DATE_FORMAT, getLuxonDateTime } from "./dateFormatter";

const ACCOUNT_ID_MAX = 20;

export const accountIdValidation = () =>
  Yup.string()
    .max(ACCOUNT_ID_MAX, `Maximum ${ACCOUNT_ID_MAX} characters`)
    .matches(/^[0-9a-zA-Z]*$/, "Invalid character");

export const dateValidation = () =>
  Yup.string().test({
    message: "Invalid date",
    test: isPassingValidDate,
  });

export function isPassingValidDate(dateValue?: string | Date) {
  const isValidJSDate =
    dateValue instanceof Date && DateTime.fromJSDate(dateValue).isValid;

  if (dateValue === undefined) return true;

  if (typeof dateValue === "string" && dateValue?.length === 0) return true;

  if (typeof dateValue === "string" && dateValue)
    return (
      !!dateValue &&
      !!DateTime.fromFormat(dateValue, DISPLAY_DATE_FORMAT).isValid
    );

  if (isValidJSDate) return true;

  return false;
}

export function isFirstDateAfterSecondDate(
  firstDate?: string | Date,
  secondDate?: string | Date
) {
  if (!firstDate) return true;
  if (!secondDate) return true;
  const startDate = getLuxonDateTime(firstDate);
  const endDate = getLuxonDateTime(secondDate);

  if (startDate && endDate && startDate < endDate) {
    return false;
  }
  return true;
}
